import { useTranslation } from "react-i18next";

interface IProps {
  isOpen: boolean;
  title: string;
  description: string[];
}
function PopupComponent(props: IProps) {
  const { i18n } = useTranslation();
  return (
    <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      {props.isOpen && (
        <div className="fixed flex top-0 left-0 inset-y-0 inset-x-0 mx-auto my-auto bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_20px_0px] w-[1161px] h-[564px] laptop:w-[950px] mobile:w-[307px] mobile:h-[606px] tablet:w-[680px] tablet:h-[765px] rounded-[32px]">
          <div className="inline-flex flex-col items-start gap-4 px-8 py-16">
            <div className="text-center text-zinc700 text-2xl mobile:text-xl font-arBold leading-9">
              {props.title}
            </div>
            <div className="flex flex-col overflow-y-scroll scrollbar mobile:scroll-mb-20">
              {props.description.map((item, index) => (
                <p
                  key={index}
                  className={`w-[1078px] pb-7 laptop:w-[850px] tablet:w-[600px] mobile:w-[224px] ${
                    i18n.language === "ar"
                      ? "text-right pr-2.5"
                      : "text-left pl-2.5"
                  }  text-zinc-400 text-lg mobile:text-sm font-arBold leading-7 `}
                >
                  {index + 1}- {item}
                </p>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PopupComponent;
